module.exports = __webpack_public_path__ + "static/c1logo-c82122d2ab42c4eb4dab282d9cdee5db.png";